import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import '../style/consultingOffer.css';

function ConsultingOffer() {
  const { t } = useTranslation();

  return (
    <section id="consulting-offer" className="consulting-offer-block">
      <Container>
        <Row className="align-items-center">
          <Col md={7}>
            <div className="offer-content">
              <h2>{t('consultingOffer.title')}</h2>
              <p className="lead">{t('consultingOffer.subtitle')}</p>
              <p>{t('consultingOffer.description')}</p>
              <Link to="/consulting">
                <Button variant="primary" size="lg">
                  {t('consultingOffer.button')} <i className="fas fa-arrow-right"></i>
                </Button>
              </Link>
            </div>
          </Col>
          <Col md={5}>
            <div className="offer-image">
              <img 
                src={require('../assets/images/consulting.jpg')} 
                alt={t('consultingOffer.imageAlt')} 
                className="img-fluid rounded shadow"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ConsultingOffer;
